import * as d3 from 'd3-selection'
import { drag } from 'd3-drag'
import connectorData from './data'
import { Connector } from '../../wob'

function arrow (selection) {
  var path = selection.selectAll('path.arrowhead')
                      .data(function (d) {
                        let [pt1, pt2] = d.to.intersection

                        if (!pt1 || !pt2) {
                          return []
                        }

                        var v = {
                            x: pt2[0] - pt1[0],
                            y: pt2[1] - pt1[1]
                          }
                          , vl = Math.sqrt(v.x * v.x + v.y * v.y)
                          , theta = Math.acos(v.x / vl) * 180 / Math.PI

                        if (v.y < 0) {
                          theta = 360 - theta
                        }

                        return [{
                          theta,
                          x: pt1[0],
                          y: pt1[1],
                          opacity: d.connector.get('style')['opacity'],
                          width: d.arrowWidth
                        }]
                     })
  path.exit().remove()

  path.enter()
      .append('path')
      .attr('class', 'arrowhead')
      .merge(selection.selectAll('path.arrowhead'))
      .attr('d', function (d) {
        return `M0,0L${d.width * 2},${d.width}L0,${d.width * 2}Z`
      })
      .style('opacity', d => d.opacity)
      .attr('transform', function (d) {
        let offset = 1
        return `translate(${d.x},${d.y - d.width}) rotate(${d.theta} 0 ${d.width})`
      })
}

function controls (selection, canvas) {
  // There are two controls that can be moved on each connector:
  var _drag = drag().on('start', function (e, d) {
                    var data = d3.select(this.parentNode).datum()
                    canvas.history.record()
                    if (d.position === 'to') {
                      // Store the original `to` connector in case we need to reattach the HEAD
                      data.connector.set('_to', data.connector.get('to'), {silent: true})
                    }

                    data.connector.trigger('change:configurable', data.connector, false)
                  })
                  .on('drag', function (e, d) {
                    // TODO this isn't efficient. Just know if we have a head set we need to disable
                    canvas.collection.each(function (wob) {
                      wob.setConnectorHead(false)
                    })
                    canvas.resize()

                    var data = d3.select(this.parentNode).datum()

                    if (d.position === 'mid') {
                      var x2 = d.coords[0] = e.x
                        , y2 = d.coords[1] = e.y

                      // Check if we should snap so the line is straight
                      var x1 = data.from.center[0]
                        , y1 = data.from.center[1]
                        , x3 = data.to.center[0]
                        , y3 = data.to.center[1]
                        , diff = Math.abs(((y2 - y1) * (x3 - x1)) - ((y3 - y1) * (x2 - x1)))
                        , threshold = 2500

                      if (diff < threshold) {
                        // Set this to be the midpoint of the two wobs, this matches keynote behavior
                        d.coords[0] = (x1 + x3) / 2
                        d.coords[1] = (y1 + y3) / 2
                      }

                      data.connector.set('control', d.coords, {silent: true})
                      // This will need to be recalculated
                      data.connector.set('midpointPercentage', null, {silent: true})

                      d3.select(this.parentNode)
                        .datum(function (d) {
                          return connectorData(d.connector, canvas)
                        })
                        .call(build, canvas)
                    } else {
                      // HEAD
                      var connected = canvas.collection.filter(function (wob) {
                                                         return !!wob.widget.connectable && wob !== data.connector.collection.from
                                                       })
                                                       .filter(function (wob) {
                                                         return wob.inArea({
                                                           left: e.x,
                                                           width: 1,
                                                           top: e.y,
                                                           height: 1
                                                         })
                                                       })
                                                       .sort(function (a, b) {
                                                         return a.get('z-index') - b.get('z-index')
                                                       })
                        , attachWob = connected[0]

                      if (attachWob) {
                        // Lock it into this wob
                        attachWob.setConnectorHead(true)
                        data.connector.set('to', attachWob, {silent: true})
                      } else {
                        // Break the connection
                        data.connector.set('to', null, {silent: true})
                        data.connector.set('toCenter', [e.x, e.y], {silent: true}) // Define a toCenter that matches the mouse position
                      }

                      d3.select(this.parentNode)
                        .datum(function (d) {
                          return connectorData(d.connector, canvas)
                        })
                        .call(build, canvas)
                      return
                    }
                  })
                  .on('end', function (e, d, i) {
                    // TODO this isn't efficient. Just know if we have a head set we need to disable
                    canvas.collection.each(function (wob) {
                      wob.setConnectorHead(false)
                    })

                    var data = d3.select(this.parentNode).datum()
                    if (i === 1 && !data.connector.get('to')) {
                      // Undo the history state from the start of the drag
                      canvas.history.state.pop()

                      // They finished dragging the attach point control, reattach to the original to connector if we're floating
                      data.connector.set('to', data.connector.get('_to'), {silent: true})
                      data.connector.set('_to', null, {silent: true})
                      d3.select(this.parentNode)
                        .datum(function (d) {
                          return connectorData(d.connector, canvas)
                        })
                        .call(build, canvas)
                    }

                    // Emit a change event on the originating wob
                    data.connector.collection.from.trigger('change', data.connector.collection.from, {})
                    data.connector.trigger('change:configurable', data.connector, true, selection.select('.connector-control-from-connection').node(), data.intersectionOffset)
                  })

  var enter = selection.selectAll('circle.connector-control')
                       .data(function (d) {
                          return [
                            {position: 'from', coords: d.from.intersection}, // from connection. No wrapper needed since it cannot be moved
                            {position: 'mid', coords: d.connector.get('control')}, // base `midpoint`
                            {position: 'mid', coords: d.connector.get('control')},  // wrapper for larger click target around `midpoint`
                            {position: 'to', coords: d.to.intersection[1] }, // base point for `to` connection
                            {position: 'to', coords: d.to.intersection[1] } // wrapper for larger click target around `to` connection
                          ]
                        })
                       .enter()
                       .append('circle')
                         .attr('class', 'connector-control')

  enter.filter((d, i) => i > 0)
       .attr('r', 6)

  enter.filter((d, i) => i > 0 && i % 2 == 0)
       .classed('connector-control-click-target', true)
       .call(_drag)
       .attr('r', 20)

  enter.filter(function (d, i) {
         return i === 0
       })
       .attr('r', 7)

  enter.merge(selection.selectAll('circle.connector-control'))
       .classed('hide', function (d) {
         return !d3.select(this.parentNode).datum().path // No path is drawn, so let's hide the controls
       })
       .classed('connector-control-from-connection', (d, i) => i === 0)
       .classed('connector-control-mid', (d, i) => i === 1)
       .attr('cx', d => d ? d.coords[0] : 0)
       .attr('cy', d => d ? d.coords[1] : 0)

  selection
    .selectAll('use.connector-settings-icon')
    .data(function (d) {
      return [d.from.intersection]
    })
    .enter()
    .append('use')
      .attr('href', '#connector-settings-icon')
      .attr('class', 'connector-settings-icon')
      .attr('height', 8)
      .attr('width', 8)
      .merge(selection.selectAll('use.connector-settings-icon'))
      .classed('hide', d => !d)
      .attr('transform', function (d) {
        if (!d) {
          return ''
        }
        return 'translate(' + (d[0] - 4) + ',' + (d[1] - 4) + ')'
      })
}

function build (group, canvas) {
  group.classed('connector-linked', function (d) {
         return !!d.connector.get('to')
       })
       .classed('connector-selected', function (d) {
         return d.connector.get('selected')
       })

  var path = group.selectAll('path.connector-path')
                  .data(function (d) {
                    return d.path ? [d] : []
                  })
    , path2 = group.selectAll('path.connector-path-click-target')
                   .data(function (d) {
                     return d.path ? [d] : []
                   })

  path.exit().remove()
  path2.exit().remove()

  // The fat sibling of the visible main path
  path2.enter()
       .insert('path', ':nth-child(1)') // Make sure the paths are always before the controls
       .attr('class', 'connector-path-click-target')
       .on('click', function (e, d) {

         if (e.shiftKey && d.connector.get('selected')) {
           // Shift key to unselect this already selected connector
           canvas.connectorsSelection.remove(d.connector)
           return
         }

         if (!e.shiftKey && !d.connector.get('selected')) {
           // It's not selected and we're about to select it without a multi select shift key indicator,
           // so deselect all other items on the canvas
           canvas.deselectAll()
         }

         // This will force a redraw and the connector will draw its control points
         canvas.connectorsSelection.add(d.connector)

         // This is weird and unclear, but it seems like redrawing the selectors and potentially re-sorting the elements
         // causes `this` to be swapped with the new element based on the original index, so we can't rely on it.
         // Instead, grab the intersection node based on the connector's `cid`
         var intersection = d3.select(`.connectors-container g.connector#connector-${d.connector.cid}`)
                              .select('.connector-control-from-connection').node()

         // Anytime the user clicked on a connector, it's configurable.
         d.connector.trigger('change:configurable', d.connector, true, intersection, d.intersectionOffset)
       })
       .merge(path2)
       .attr('d', function (d) {
         return d.path
       })

  path.enter()
      .insert('path', ':nth-child(2)') // Make sure the path is below the controls
      .attr('class', 'connector-path')
      .merge(path)
      .attr('d', function (d) {
        return d.path
      })
      .style('stroke-width', function (d) {
        return d.connector.get('style')['stroke-width']
      })
      .style('stroke-dasharray', function (d) {
        // We have default stroke-dasharrays, but we want to scale them based on the stroke-width
        var dashArray = d.connector.get('style')['stroke-dasharray']
          , width = d.connector.get('style')['stroke-width']
          , defaultWidth = Connector.prototype.defaults.style['stroke-width']

        if (dashArray) {
          var vals = dashArray.split(' ')
            , dashMultiplier = vals[0] / defaultWidth
            , gapMultiplier = vals[1] / defaultWidth

          return (width * dashMultiplier) + ' ' + (width * gapMultiplier)
        } else {
          return ''
        }
      })
      .style('opacity', function (d) {
        return d.connector.get('style')['opacity']
      })

  group.call(controls, canvas)
       .call(arrow)
}

function connectorGroup (selection, canvas) {
  var _group = selection.selectAll('g.connector')
                        .data(function (d) {
                          return d.filter(function (connector) {
                                    return !(connector.get('to') && !canvas.views[connector.get('to').cid])
                                  })
                                  .map(function (connector) {
                                    return connectorData(connector, canvas)
                                  })
                                  .sort(function (a, b) {
                                    // Sort so we always draw the selected connector last
                                    return a.connector.get('selected') - b.connector.get('selected')
                                  })
                        })
    , group = _group.enter()
                    .append('g')
                      .attr('class', 'connector')
                      .merge(_group)
                      .attr('id', d => `connector-${d.connector.cid}`)
                      .classed('read-only', d => d.connector.get('readonly'))

  _group.exit().remove()

  group.each(function () {
         d3.select(this).call(build, canvas)
       })
}

// A connector is composed of a group of smaller parts, such as the
// Path, control points, arrows, etc.
// This updates a single connector
export default function (selection, canvas, wobId, data) {
  // Each wob has a group for all its connectors
  var _group = selection.selectAll('g.connector-group.connector-group-wob-' + wobId)
                        .data(function () {
                          return data.length ? [data] : []
                        })
    , group = _group.enter()
                    .append('g')
                      .attr('class', 'connector-group connector-group-wob-' + wobId)
                      .merge(_group)
                      .call(connectorGroup, canvas)

  _group.exit().remove()
}
